<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar" v-bind:class="{ branded: embed.enabled }">
            <div class="left">
                <a v-on:click="$router.go(-1)">
                    <svg class="icon icon-arrow-back" aria-hidden="true"></svg>
                </a>
            </div>
            <div class="right">
                <router-link v-bind:to="{ name: 'Outlets' }" v-bind:title="'Outlets'" data-test-id="href-home">
                    <svg class="icon-close" aria-hidden="true"></svg>
                </router-link>
            </div>
        </ons-toolbar>

        <div class="content main-background">

            <v-ons-progress-bar v-if="show_loading" indeterminate/>

            <div class="content-inner">
                <div v-if="email_sent == false">
                    <div class="main-header left">
                        Forgot password?
                    </div>

                    <div class="main-text mt-16">
                        Enter your email and we'll send instructions on how to reset your password
                    </div>

                    <div class="mt-10">
                        <v-ons-list class="list-no-divider">
                            <v-ons-list-item>
                                <div class="center">
                                    <v-ons-input float placeholder="Enter your email" type="email" v-model="email" data-test-id="inp-email"/>
                                </div>
                            </v-ons-list-item>
                        </v-ons-list>
                        <gtc-button v-on:click="submit" v-bind:disabled="can_continue == false" class="btn-action mt-20"
                                    data-test-id="btn-forgot-password">
                            Send email
                        </gtc-button>
                    </div>
                </div>
                <div v-if="email_sent">
                    <div class="email-icon">
                        <img src="/forgot-password.svg" width="120" height="120">
                    </div>
                    <br>
                    <div class="main-header center ">Check your email</div>
                    <div class="main-text mt-16" style="text-align: center">
                        We've sent instructions on how to reset the password (also check Spam folder).
                    </div>
                    <div class="section-vh big-button-container stick-bottom" data-test-id="btn-forgot-resend">
                        <gtc-button v-on:click="submit" v-bind:disabled="can_continue == false" class="btn-action mb-20">
                            Didn't receive the email? Send again
                        </gtc-button>
                    </div>
                </div>
            </div>

        </div>
    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'
    import { default as ForgotPasswordMixin } from '../../mixins/forgot_password'

    export default {

        mixins: [ForgotPasswordMixin],

        mounted(){

        },

        data () {
            return {
                app: this.$root.$data.app,
                email: '',
                loading: false,
                email_sent: false
            }
        },

        methods: {

            submit(){

                if (this.can_continue == false)
                    return

                this.sendForgotPasswordResetEmail(this.email)
                    .then(() => {
                        this.loading = false
                        this.email_sent = true
                    })
                    .catch(() => {
                        this.loading = false
                        this.email_sent = false
                    })
            }
        },

        computed: {

            ...mapGetters([
               'embed',
            ]),

            show_loading: function(){
                return this.loading
            },

            can_continue: function(){
                return this.email && this.email.length > 0
            }
        },

        watch: {

        }
    }
</script>

<style scoped>

    .email-icon{        
        display: flex;
        justify-content: center;
        margin-top: 40%;
    }

</style>


// WEBPACK FOOTER //
// src/js/components/user/forgot_password.vue